// extracted by mini-css-extract-plugin
module.exports = {"form":"xK07Y"};